import MinervaInfo from './container';
export default MinervaInfo;
